import { Box, Button, Grid2, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Step2 = ({ sra, setSra, setStep, storedUser }) => {
  const [btnLoading, setBtnLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleChange = (e) => {
    setSra({ ...sra, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    const newErrors = {};
    const data = sra || {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    if (isEmpty(data.amount)) {
      newErrors.amount = "Amount is required";
    } else if (isNaN(Number(data.amount)) || Number(data.amount) <= 0) {
      newErrors.amount = "Enter a valid amount greater than 0";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = async () => {
    if (!validateForm()) return;
    setBtnLoading(true);
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/draft-tender-deposit?draftSraId=${sra.draftTenderDepositId}`,
        {
          amount: sra.amount,
          transactionId: sra.transactionId,
          method: sra.method,
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setStep((prev) => prev + 1);
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleBack = () => {
    navigate(`/approval/dashboard/create-tender-deposit/draft/${sra.draftTenderDepositId}`)
    setStep((prev) => prev - 1);
  };

  return (
    <div style={{ position: "relative" }}>
      {btnLoading && <div className="loading-div"></div>}
      <h2>Tender Deposit Form</h2>
      <div className="progress-container">
        <span className="blue-bar" style={{ width: "40%" }}></span>
      </div>
      <div className="dashboard-container">
        <Box>
          <Typography className="form-title">Justification</Typography>
          <Grid2 container columnSpacing={2}>
            <Grid2 size={{ xs: 12, sm: 4 }}>
              <label htmlFor="amount">
                Deposit Amount <span style={{ color: "#FF0000" }}>*</span>
              </label>
              <input
                className={`${errors.amount && "input-error"}`}
                type="number"
                step="0.01"
                name="amount"
                id="amount"
                onChange={handleChange}
                value={sra?.amount || ""}
              />
              {errors.amount && <p className="error">{errors.amount}</p>}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 4 }}>
              <label htmlFor="transactionId">
                Transaction ID
              </label>
              <input
                className={`${errors.transactionId && "input-error"}`}
                type="text"
                name="transactionId"
                id="transactionId"
                onChange={handleChange}
                value={sra?.transactionId || ""}
              />
              {errors.transactionId && (
                <p className="error">{errors.transactionId}</p>
              )}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 4 }}>
              <label htmlFor="method">
                Payment Method
              </label>
              <input
                className={`${errors.method && "input-error"}`}
                type="text"
                name="method"
                id="method"
                onChange={handleChange}
                value={sra?.method || ""}
              />
              {errors.method && <p className="error">{errors.method}</p>}
            </Grid2>
          </Grid2>
        </Box>
      </div>
      <Box className="btn-container" sx={{ gap: 3 }}>
        <Button className="btn-outlined" onClick={handleBack}>
          Back
        </Button>
        <Button
          className="btn-contained"
          onClick={handleNext}
          disabled={btnLoading}
        >
          {btnLoading ? "Submitting..." : "Next"}
        </Button>
      </Box>
    </div>
  );
};

export default Step2;
